export const SPECIAL_OFFERS_LIST_KEY = 'SPECIAL_OFFERS_LIST';
export const SPECIAL_OFFERS_ONE_KEY = 'SPECIAL_OFFERS_ONE_KEY';
